import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/Components/shadcn/tooltip';

export interface CandidatesListToolTipProps {
    title: string;
    children: React.ReactElement;
}

const CandidatesListToolTip = ({ title, children }: CandidatesListToolTipProps) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent className="max-w-xs font-medium">{title}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default CandidatesListToolTip;
